import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

interface OverlayContextProps {
  onCloseClick: () => void;
}

export const OverlayContext = createContext<OverlayContextProps>(undefined!);

export const useOverlayContext = () => useContext(OverlayContext);
